module.exports = __webpack_public_path__ + "static/img/14058B_4_R_20200730_fit.d34edeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/14058B_4_R_20200730_fit.png
// module id = gCiv
// module chunks = 0